<template>
  <v-flex xs12 ma-4>
    <DialogVideoPlayer
      :show.sync="videoDialog.show"
      :src.sync="videoDialog.src"
    />

    <v-row
      no-gutters
      class="mb-1"
    >
      <v-btn
        @click="isShowHidden=!isShowHidden"
      >
        {{ isShowHidden ? 'Hide hidden' : 'Show hidden' }}
      </v-btn>
    </v-row>
    <v-row
      v-if="isShowHidden"
      no-gutters
      class="my-3"
    >
      Hidden videos
    </v-row>
    <v-row
      v-if="isShowHidden"
      no-gutters
    >
      <v-col
        v-for="video in hiddenVideos"
        :key="video.id"
      >
        <VideoPreviewCard
          :video="video"
          :is-editable="false"
          @toggleHideVideo="toggleHideVideo"
          @updateVideoInfo="updateVideoInfo($event, true)"
          @deleteVideo="deleteVideo"
          @openPlayVideoDialog="openPlayVideoDialog"
          @setSnack="setSnack"
        />
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="my-3"
      v-if="isShowHidden"
    >
      Other videos
    </v-row>

    <v-row no-gutters>
      <v-col
        v-for="video in videos"
        :key="video.id"
      >
        <VideoPreviewCard
          :video="video"
          :is-editable="false"
          @toggleHideVideo="toggleHideVideo"
          @updateVideoInfo="updateVideoInfo($event, false)"
          @deleteVideo="deleteVideo"
          @openPlayVideoDialog="openPlayVideoDialog"
          @setSnack="setSnack"
        />
      </v-col>
    </v-row>

    <v-row
      no-gutters
      class="my-3"
      v-if="duplicateVideos.length"
    >
      Duplicate videos
    </v-row>

    <v-row
      v-if="duplicateVideos.length"
      no-gutters
    >
      <v-col
        v-for="video in duplicateVideos"
        :key="video.id"
      >
        <VideoPreviewCard
          :video="video"
          :is-editable="false"
          @toggleHideVideo="toggleHideVideo"
          @updateVideoInfo="updateVideoInfo($event, false)"
          @deleteVideo="deleteVideo"
          @openPlayVideoDialog="openPlayVideoDialog"
          @setSnack="setSnack"
        />
      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import VideoPreviewCard from '../components/VideoPreviewCard.vue';
import DialogVideoPlayer from '../components/dialogs/DialogVideoPlayer.vue';

export default {
  name: 'StuckedVideo',
  components: {
    VideoPreviewCard,
    DialogVideoPlayer,
  },
  data: () => ({
    isShowHidden: false,
    videos: [],
    duplicateVideos: [],
    hiddenVideos: [],
    selectedVideo: {
      id: null,
      sourceId: null,
    },
    videoDialog: {
      show: false,
      src: '',
    },
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/video/getBrokenVideos')
      .then((response) => {
        this.videos = response.data.filter((el) => !el.is_hidden);
        this.hiddenVideos = response.data.filter((el) => el.is_hidden);
      });

    this.$requestHelpers
      .get('api/admin/video/getDuplicateVideos')
      .then((response) => {
        this.duplicateVideos = response.data;
      });
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    toggleHideVideo({ videoId, response }) {
      if (response.data.success) {
        this.setSnack({
          color: 'green',
          text: response.data.message ? response.data.message : 'done',
        });

        if (response.data.result.is_hidden) {
          this.videos = this.videos.filter((el) => el.id !== videoId);
          this.hiddenVideos.push(response.data.result);
        } else {
          this.hiddenVideos = this.hiddenVideos.filter((el) => el.id !== videoId);
          this.videos.push(response.data.result);
        }
      } else {
        this.setSnack({
          color: 'red',
          text: response.data.message,
        });
      }
    },

    updateVideoInfo({ videoId, response }, isHidden) {
      if (response.data.is_broken && isHidden) {
        this.hiddenVideos = this.hiddenVideos.map(
          (video) => (video.id !== videoId
            ? video
            : Object.assign(video, response.data)),
        );
      } else if (response.data.is_broken && !isHidden) {
        this.videos = this.videos.map(
          (video) => (video.id !== videoId
            ? video
            : Object.assign(video, response.data)),
        );
      } else if (isHidden) {
        this.hiddenVideos = this.hiddenVideos.filter((video) => video.id !== videoId);
      } else {
        this.videos = this.videos.filter((video) => video.id !== videoId);
      }

      this.setSnack({
        color: 'green',
        text: 'updated',
      });
    },

    deleteVideo(videoId) {
      this.videos = this.videos.filter((video) => video.id !== videoId);
      this.duplicateVideos = this.duplicateVideos.filter((video) => video.id !== videoId);
    },

    openPlayVideoDialog(videoSrc) {
      Object.assign(this.videoDialog, { show: true, src: videoSrc });
    },
  },

};
</script>

<style scoped>

</style>
